// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__rBC1-","dark":"Logo_dark__Bih9-"};